export enum TestStatus {
	Passed = "Passed",
	Failed = "Failed",
	InProgress = "In Progress",
	NotTaken = "Not Taken"
}
